import axios from 'axios'
import { Message } from 'element-ui'
// MessageBox
import store from '@/store'
import { getToken } from '@/utils/auth'

// 创建一个axios实例
const service2 = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_tagging // url = base url + request url   http://47.102.147.241
  // withCredentials: true, // 当跨域请求时发送cookie
  // timeout: 15000 // 请求超时
})
// request 拦截器
service2.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    if (store.getters.token) {
      // 让每个请求携带 token
      // ['X-Token']是一个自定义头键
      // 请根据实际情况修改
      config.headers['Token'] = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor 拦截器
service2.interceptors.response.use(
  /**
   * 如果您想获得http信息，例如头信息或状态信息
   * Please return  response => response
  */
  /**
   * 通过自定义代码确定请求状态
   * 这只是个例子
   * 还可以通过HTTP状态代码来判断状态
   */
  response => {
    const res = response.data

    // 如果自定义代码不是20000，则判断为错误。
    if (res.status_code !== 200) {
      Message({
        message: res.message || 'Error状态错误',
        type: 'error',
        duration: 5 * 1000
      })

      // 50008:非法令牌;50012:其他客户登录;403:令牌过期;
      if (res.status_code === 403 || res.code === 50012 || res.code === 50014) {
        // to re-login
        // MessageBox.confirm('token令牌过期，您可以取消以停留在此页面，或再次登录', '确认注销', {
        //   confirmButtonText: 'Re-Login',
        //   cancelButtonText: 'Cancel',
        //   type: 'warning'
        // }).then(() => {
        store.dispatch('user/resetToken').then(() => {
          location.reload()
        })
        // })
      }
      // return Promise.reject(new Error(res.message || 'Error1'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service2
